import ErrorHandler from '@module/error-handler';
import Translations from '@module/i18n/dictionary';
import Logger from '@module/logger';
import Store from '@app/store';

// Get current session from Store
const { session } = Store.getState();

// Set the possible locales we support
Translations.setLocales({
  en: ['English', 'English'],
  nl: ['Nederlands', 'Dutch'],
  it: ['Italiano', 'Italian'],
  fr: ['Français', 'French'],
  de: ['Deutsch', 'German'],
  es: ['Español', 'Spanish'],
  pt: ['Português', 'Portuguese'],
  tr: ['Türkçe', 'Turkish'],
  nb: ['Bokmål', 'Norwegian Bokmål'],
  da: ['Dansk', 'Danish'],
  sv: ['Svenska', 'Swedish'],
});

// Set the current dictionary for locale
Translations.update(session.language || 'en', window['_i18n_'] || {});

// Let's record missing keys (only report unique keys once during a session)
const recordedMissing = [];
Translations.onMissingKey = (key) => {
  Logger.error(`Translation key missing: ${key}`);

  if (recordedMissing.indexOf(key) !== -1) {
    return;
  }
  recordedMissing.push(key);

  ErrorHandler.addMetadata('locale', Translations.locale);
  ErrorHandler.addMetadata('key', key);

  ErrorHandler.track({
    name: 'MissingLocale',
    message: `Translation key ${key} is missing for locale ${Translations.locale}`,
    stack: 'init/locale',
  });
};

// Remove dictionary from document
window['_i18n_'] = null;
